module.exports = __webpack_public_path__ + "img/full2-min.56382188.png";